const phoneNumberQueryKeys = {
  all: ['phoneNumber'] as const,
  list: (
    orderBy: any,
    filters: any,
    queryPageSize: number,
    queryPageIndex: number,
  ) =>
    [
      ...phoneNumberQueryKeys.all,
      'list',
      orderBy,
      filters,
      queryPageSize,
      queryPageIndex,
    ] as const,
  byId: (id: string | undefined | null) =>
    [...phoneNumberQueryKeys.all, id] as const,
};

export default phoneNumberQueryKeys;
